<p class="hle-note" *ngIf="isNotAllowed">
  <i class="pi pi-lock" aria-hidden="true"></i>
  {{
    leadId
      ? 'This buyer is not one of yours, so their activity on this lot is not shown.'
      : 'None of your buyers has viewed or shortlisted this lot, so its activity is not shown.'
  }}
</p>

<section class="hle" *ngIf="data">
  <header class="hle__head">
    <h3 class="hle__title">Horizon Engagement</h3>
    <div class="hle__range">
      <ng-select
        [items]="dateRanges"
        bindLabel="label"
        bindValue="value"
        [searchable]="false"
        [clearable]="false"
        [(ngModel)]="selectedDays"
        (change)="load()"></ng-select>
    </div>
  </header>

  <!-- Two sections: the lot's figures as equal tiles across the width, then the buyers behind them. -->
  <div class="hle__section">
    <h4 class="hle__subtitle">{{ leadId ? "This buyer's activity on the lot" : 'Lot activity' }}</h4>
    <div class="hle__tiles" [style.--hle-tiles]="summaryCards.length">
      <div class="hle__tile" *ngFor="let card of summaryCards" [attr.title]="metric(card.key) ? null : 'Not tracked yet'">
        <span class="hle__icon"><i [class]="card.icon" aria-hidden="true"></i></span>
        <span class="hle__value">{{ metric(card.key)?.value ?? '—' }}</span>
        <span class="hle__label" [title]="card.label">{{ card.label }}</span>
        <ng-container *ngIf="metric(card.key) as m">
          <span class="hle__change" *ngIf="hasComparison(m)" [class.hle__change--down]="m.change_pct < 0">
            <i [class]="m.change_pct < 0 ? 'fa-solid fa-arrow-down' : 'fa-solid fa-arrow-up'" aria-hidden="true"></i>
            {{ m.change_pct < 0 ? -m.change_pct : m.change_pct }}%
          </span>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="hle__section" *ngIf="!leadId">
    <h4 class="hle__subtitle">Buyers viewing this lot</h4>
    <p class="hle__empty" *ngIf="!data.leads?.length">No buyer has viewed this lot in this period.</p>
    <table class="hle__table" *ngIf="data.leads?.length">
      <thead>
        <tr>
          <th>Lead</th>
          <th>Views</th>
          <th>Shortlisted</th>
          <th>Last Viewed</th>
          <th>Engagement</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lead of data.leads; trackBy: trackByIndex">
          <td>{{ lead.name }}</td>
          <td>{{ lead.views }}</td>
          <td>{{ lead.shortlisted ? 'Yes' : 'No' }}</td>
          <td>{{ formatDate(lead.last_viewed_at) }}</td>
          <td>
            <span class="hle__badge" [ngClass]="'hle__badge--' + lead.engagement_level">{{ lead.engagement_level | titlecase }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
